type Template = {
  name: string;
  description: string;
  starter: boolean;
  cost?: number;
  extMainTag?: string;
  tallThumbnailImg?: string;
};

export const blankTemplate: Template = {
  cost: 0,
  description:
    'Start from a blank canvas — and build exactly what you’re envisioning.',
  extMainTag: 'Preset',
  name: 'Blank Site',
  starter: true,
  tallThumbnailImg:
    'https://daks2k3a4ib2z.cloudfront.net/52b1d97cd25933e36e000134/56e21ed33af9c087302c3eb2_empty.png',
};

// Should appear like a blank site
export const quickAddTemplate: Template = {
  name: 'Quick Add Template',
  description:
    'Start from a blank canvas — and build exactly what you’re envisioning.',
  starter: true,
};
